/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss?v=1.2.0";
import "assets/demo/demo.css?v=1.2.0";
// pages
import Index from "views/Index.js";
import NucleoIcons from "views/NucleoIcons.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import ComponentGallery from "views/examples/ComponentGallery.js";
import RegisterPage from "views/examples/RegisterPage.js";
import About from "views/About.js";
import KatieProfile from "views/KatieProfile.js";
import Inquiry from "views/Inquiry.js";
import Courses from "views/Courses.js";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route
        path="/nucleo-icons"
        render={(props) => <NucleoIcons {...props} />}
      />
      <Route
        path="/landing-page"
        render={(props) => <LandingPage {...props} />}
      />
      <Route
        path="/profile-page"
        render={(props) => <ProfilePage {...props} />}
      />
      <Route
        path="/katie-profile"
        render={(props) => <KatieProfile {...props} />}
      />
      <Route path="/inquiry" render={(props) => <Inquiry {...props} />} />
      <Route path="/about" render={(props) => <About {...props} />} />
      <Route path="/courses" render={(props) => <Courses {...props} />} />
      <Route
        path="/register-page"
        render={(props) => <RegisterPage {...props} />}
      />{" "}
      <Route
        path="/component-gallery"
        render={(props) => <ComponentGallery {...props} />}
      />
      <Route path="/" render={(props) => <Index {...props} />} />
      <Redirect to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
